import React from "react";
import styled, { css } from "styled-components";
import Link from "next/link";
import { device } from "../../services/styles";

const Row = styled.div`
  margin-left: 0px;
  @media ${device.tabletLarge} {
    margin-left: 0;
  }
  @media print {
    display: none;
  }
`;

const cssLink = css`
  margin: 0 15px 10px 0;
  display: inline-block;
  font-size: 13px;
  line-height: 1;
  color: #777777;
`;

const GrayLink = styled.a`
  ${cssLink};
  cursor: pointer;
`;

const GraySpan = styled.span`
  ${cssLink};
`;

export const ArticleListBreadcrumbs = ({
  categorySlug,
  categoryName,
  mainCategory,
  article,
  tagName,
}) => {
  return (
    <Row>
      <Link href="/" passHref={true}>
        <GrayLink>Strona główna</GrayLink>
      </Link>
      {mainCategory && (
        <>
          <GraySpan>{`>`}</GraySpan>
          <Link href="/artykuly">
            <GrayLink>Artykuły</GrayLink>
          </Link>
          <GraySpan>{`>`}</GraySpan>
          <Link
            href={"/artykuly/[category]"}
            as={`/artykuly/${mainCategory.slug}`}
            passHref={true}
          >
            <GrayLink>{mainCategory.name}</GrayLink>
          </Link>
        </>
      )}
      {tagName && (
        <>
          <GraySpan>{`>`}</GraySpan>
          <GraySpan>{tagName}</GraySpan>
        </>
      )}
      {!tagName && categorySlug && (
        <>
          <GraySpan>{`>`}</GraySpan>
          <Link
            href={"/artykuly/[category]"}
            as={`/artykuly/${categorySlug}`}
            passHref={true}
          >
            <GrayLink>{categoryName}</GrayLink>
          </Link>
        </>
      )}
      {article && (
        <>
          <GraySpan>{`>`}</GraySpan>
          <GraySpan>{article}</GraySpan>
        </>
      )}
    </Row>
  );
};

export const Breadcrumbs = ({ sites, activeSite }) => {
  return (
    <Row>
      <Link href="/" passHref={true}>
        <GrayLink>Strona główna</GrayLink>
      </Link>
      {sites.map((site) => (
        <React.Fragment key={site.name}>
          <GraySpan>{`>`}</GraySpan>
          <Link href={site.href} as={site.as} passHref={true}>
            <GrayLink>{site.name}</GrayLink>
          </Link>
        </React.Fragment>
      ))}
      {activeSite && (
        <>
          <GraySpan>{`>`}</GraySpan>
          <GraySpan>{activeSite}</GraySpan>
        </>
      )}
    </Row>
  );
};
